import React from 'react';
import { Link } from "react-router-dom";
import PageLayout from '../../component/PageLayout';
import ProductTallyPrimeTabs from '../../component/Product-TallyPrime';
import IconRightArrow from '../../component/SvgIcons/IconRightArrow';
import IconTallyPrimelogo from '../../component/SvgIcons/IconTallyPrimelogo';
import './style.css';

export default function TallySoftwareService() {
  return (
    <div className='TallyPrimebg fourtab'>
    <PageLayout>
    <ProductTallyPrimeTabs/>
    <section className="TabFirstTallyPrime-tab pt50 pb100">
    <div className="container">
    <div className="titletwo col-sm-12 col-md-12 col-lg-12 text-center">
                <h2>
                  Powerful upgrades & connected services for your <span>growing business</span>
                </h2>
              </div>


            <div
              className="keyfeatures-main flex-column flex-md-row d-flex gap30">
              <div className="keyfeatures-picture box-default d-flex align-items-center justify-content-center">
                <img
                  src="../images/tally-software-service/e-way-bills-instantly.png"
                  alt="Connected Services to Generate e-Way Bills Instantly"
                />
              </div>
              <div className="keyfeatures-information box-default d-flex justify-content-center flex-column">
                <h5>Connected Services to Generate e-Way Bills Instantly</h5>
                <p>
                  Tally’s fully connected e-way bill solution is simple,
                  seamless and reliable with zero manual work. Tally being one
                  of the recognised ISO certified GSP (GST Suvidha Provider),
                  Tally directly integrates with the e-way portal to seamlessly
                  generate e-way bill for you without the need to do it
                  manually.
                </p>
              </div>
            </div>

            <div
              className="keyfeatures-main  d-flex flex-md-row-reverse flex-column flex-md-row flex-sm-column gap30">
              <div className="keyfeatures-picture box-default d-flex justify-content-center align-items-center">
                <img
                  src="../images/tally-software-service/e-Invoice.png"
                  alt="Connected Service to Generate e-Invoice"
                />
              </div>
              <div className="keyfeatures-information box-default d-flex justify-content-center flex-column">
                <h5>Connected Service to Generate e-Invoice</h5>
                <p>
                  Generating and printing e-invoice is amazingly simpler with
                  Tally’s connected services. Tally being a recognized and ISO
                  certified GSP (GST Suvidha Provider), Tally directly
                  integrates with IRP portal to seamlessly generate e-invoices.
                </p>
              </div>
            </div>

            <div
              className="keyfeatures-main flex-column flex-md-row d-flex gap30">
              <div className="keyfeatures-picture box-default d-flex justify-content-center align-items-center">
                <img
                  src="../images/tally-software-service/business-reports.png"
                  alt="Business Reports on Any Device, Anywhere"
                />
              </div>
              <div className="keyfeatures-information box-default d-flex justify-content-center flex-column">
                <h5>Business Reports on Any Device, Anywhere</h5>
                <p>
                  Real-time and secure access to important business report from
                  a web browser, on any device, anywhere.
                </p>
                <ul>
                  <li>
                    View your important business reports anywhere on a web
                    browser
                  </li>
                  <li>
                    Convenience of accessing your data anywhere while your data
                    stays only with you
                  </li>
                  <li>
                    Access important business reports such as Bills Receivable &
                    Payable, Stock Summary, Sales/Purchase Register, Profit &
                    Loss A/C, Balance Sheet etc on the go
                  </li>
                  <li>
                    Helping you make the business decisions faster than before
                  </li>
                  <li>
                    You can download an invoice or any report and share it on
                    the go
                  </li>
                </ul>
              </div>
            </div>

            <div
              className="keyfeatures-main d-flex flex-md-row-reverse flex-column flex-md-row flex-sm-column gap30">
              <div className="keyfeatures-picture box-default justify-content-center d-flex align-items-center">
                <img
                  src="../images/tally-software-service/productupdates.png"
                  alt="Product updates"
                />
              </div>
              <div className="keyfeatures-information box-default d-flex justify-content-center flex-column">
                <h5>Product updates</h5>
                <p>
                  Regular product updates ensure that your Tally caters to your
                  ever-changing business requirements.
                </p>
                <ul>
                  <li>
                    Avail new product enhancements & major releases at frequent
                    intervals
                  </li>
                  <li>
                    Ensure compatibility with the latest technological and
                    statutory changes
                  </li>
                </ul>
              </div>
            </div>

            <div
              className="keyfeatures-main flex-column flex-md-row d-flex gap30">
              <div className="keyfeatures-picture box-default justify-content-center d-flex align-items-center">
                <img
                  src="../images/tally-software-service/digital-payment-request.png"
                  alt="Digital Payment Request"
                />
              </div>
              <div className="keyfeatures-information box-default d-flex justify-content-center flex-column">
                <h5>Digital Payment Request</h5>
                <p>
                  Integrate with payment gateways and enjoy the benefits of a
                  single system to generate and manage payment links. What’s
                  more? You can do it with UPI as well.
                </p>
                <ul>
                  <li>
                    Supports integration with payment gateways such as PayU and
                    Razorpay for streamlined payments
                  </li>
                  <li>
                    Add payment QR code and link on the invoices, including bulk
                    generation for multiple invoices
                  </li>
                  <li>
                    Generate payment links and share them with your customers
                    through email and SMS
                  </li>
                </ul>
              </div>
            </div>

            <div
              className="keyfeatures-main d-flex flex-md-row-reverse flex-column flex-md-row flex-sm-column gap30">
              <div className="keyfeatures-picture box-default justify-content-center d-flex align-items-center">
                <img
                  src="../images/tally-software-service/remote-access.png"
                  alt="Remote Access"
                />
              </div>
              <div className="keyfeatures-information box-default d-flex justify-content-center flex-column">
                <h5>Remote Access</h5>
                <p>
                  24X7 business connectivity using our Remote Access Services
                  and manage your business from anywhere in the world.
                </p>
                <ul>
                  <li>
                    Get round the clock access to crucial information about your
                    business performance irrespective of the time or location
                  </li>
                  <li>
                    Manage cash flows, bank accounts, stock positions or
                    manufacturing time-lines even when you are not in your
                    office
                  </li>
                  <li>
                    Create and modify the business transactions and other
                    details on the go
                  </li>
                  <li>
                    Provide access to Chartered Accountants and their audit
                    clerks to audit data
                  </li>
                </ul>
              </div>
            </div>

    </div>
   

<div className='container'>
    <div className="tallypricebox-main pt50 d-flex flex-column flex-sm-row flex-md-row gap50 flex-wrap justify-content-center">
    <div className="tallypricebox graycolor box-default text-center">
              <div className="tallylogo">
                <IconTallyPrimelogo/>
              </div>
              <h4>Silver</h4>
              <p>
                <span>Single user edition For Standalone PCs</span>
              </p>
              <h1>$ 126</h1>
              <p>(+ Tax)</p>
              <div className="buybtn">
                <Link onClick={() => { window.scrollTo({ top: 0 });}} to="/contact" className="btn btn-purpal">
                  <label>Buy Now <IconRightArrow /></label> <span></span>
                </Link>
              </div>
            </div>

          <div className="tallypricebox box-default goldcolor text-center">
            <div className="tallylogo">
              <IconTallyPrimelogo />
            </div>
            <h4>Gold</h4>
            <p>
              <span>
              Unlimited multi-user edition 
                For multiple PCs on LAN environment
              </span>
            </p>
            <h1>$ 378</h1>
            <p>(+ Tax)</p>
            <div className="buybtn">
              <Link onClick={() => { window.scrollTo({ top: 0 });}} to="/contact" className="btn btn-purpal">
                <label>Buy Now <IconRightArrow /></label><span></span>
              </Link>
            </div>
          </div>
       
        </div>
        </div>
  </section>
  </PageLayout>
  </div>
  )
}
